// Copied from ot-json0

// Add transform and transformX functions for an OT type which has
// transformComponent defined.  transformComponent(destination array,
// component, other component, side)

function bootstrapTransform(type, transformComponent, append) {
  var transformComponentX = function (left, right, destLeft, destRight) {
    transformComponent(destLeft, left, right, "left");
    transformComponent(destRight, right, left, "right");
  };

  var transformX = (type.transformX = function (leftOp, rightOp) {
    var newRightOp = [];

    // This algorithm assumes both operations are arrays.
    if (!Array.isArray(leftOp)) leftOp = [leftOp];
    if (!Array.isArray(rightOp)) rightOp = [rightOp];

    for (var i = 0; i < rightOp.length; i++) {
      var rightComponent = rightOp[i];

      // Generate newLeftOp by composing leftOp by rightComponent
      var newLeftOp = [];
      var k = 0;
      while (k < leftOp.length) {
        var nextC = [];
        transformComponentX(leftOp[k], rightComponent, newLeftOp, nextC);
        k++;

        if (nextC.length === 1) {
          rightComponent = nextC[0];
        } else if (nextC.length === 0) {
          for (var j = k; j < leftOp.length; j++) {
            append(newLeftOp, leftOp[j]);
          }
          rightComponent = null;
          break;
        } else {
          // Recurse.
          var pair = transformX(leftOp.slice(k), nextC);
          for (var l = 0; l < pair[0].length; l++) {
            append(newLeftOp, pair[0][l]);
          }
          for (var r = 0; r < pair[1].length; r++) {
            append(newRightOp, pair[1][r]);
          }
          rightComponent = null;
          break;
        }
      }

      if (rightComponent != null) {
        append(newRightOp, rightComponent);
      }
      leftOp = newLeftOp;
    }
    return [leftOp, newRightOp];
  });

  // Transforms op with specified side ('left' or 'right') by otherOp.
  type.transform = function (op, otherOp, side) {
    if (!(side === "left" || side === "right"))
      throw new Error("side must be 'left' or 'right'");

    if (otherOp.length === 0) return op;

    if (op.length === 1 && otherOp.length === 1)
      return transformComponent([], op[0], otherOp[0], side);

    if (side === "left") return transformX(op, otherOp)[0];
    else return transformX(otherOp, op)[1];
  };
}

export default bootstrapTransform;
